<template>
    <form
        data-test-id="encryption-key-form"
        @submit.prevent="createEncryptionKey"
    >
        <div class="form-group">
            <label for="name">Name</label>
            <input
                id="name"
                v-model="name"
                type="text"
                required
                maxlength="20"
                data-test-id="name"
            />
        </div>

        <form-errors :response="errorResponse"></form-errors>

        <div
            v-if="showSaveAndCancel"
            class="form-group save-and-cancel"
        >
            <button
                :class="['btn', 'btn-secondary']"
                data-test-id="cancel-button"
                @click.prevent="$emit('cancel-button-clicked')"
            >
                <div>Cancel</div>
            </button>
            <button
                :class="['btn', 'btn-primary', { active: submitted }]"
                data-test-id="save-button"
                type="submit"
            >
                <div>Save</div>
            </button>
        </div>
        <div
            v-else
            class="form-group"
        >
            <button
                :class="['btn', 'btn-primary', { active: submitted }]"
                data-test-id="submit-button"
                type="submit"
            >
                <div>Create</div>
            </button>
        </div>
    </form>
</template>

<script>
import FormErrors from '@/components/FormErrors.vue'
import canToast from '@/mixins/canToast'
import hasBackButton from '@/mixins/hasBackButton'
import needsOrganizationSlug from '@/mixins/needsOrganizationSlug'

export default {
    components: {
        FormErrors,
    },

    mixins: [canToast, hasBackButton, needsOrganizationSlug],

    props: {
        createEndpoint: {
            type: String,
            required: false,
        },
        showSaveAndCancel: {
            type: Boolean,
            required: false,
            default: false,
        },
        encryptionKey: {
            type: Object,
            required: false,
        },
    },

    emits: ['encryption-key-created', 'cancel-button-clicked'],

    data() {
        return {
            name: null,
            errorResponse: null,
            submitted: false,
            maxNameLength: 20,
        }
    },

    mounted() {
        if (this.encryptionKey) {
            this.name = this.encryptionKey.name
        }
    },

    methods: {
        createEncryptionKey() {
            this.submitted = true
            const hasCustomEndpoint = this.createEndpoint !== undefined
            const endpoint = hasCustomEndpoint ? this.createEndpoint : `/${this.organizationSlug}/encryption-keys`

            this.$http
                .post(endpoint, {
                    name: this.name,
                })
                .then((data) => {
                    this.submitted = false
                    this.$emit('encryption-key-created', data.data)
                    if (!hasCustomEndpoint) {
                        this.toast('Encryption Key successfully created!')
                        this.$router.push(`/${this.organizationSlug}/encryption-keys`)
                    }
                })
                .catch((error) => {
                    this.submitted = false
                    this.errorResponse = error.response
                })
        },
    },
}
</script>

<style scoped lang="scss">
.save-and-cancel {
    text-align: right;

    button {
        margin-left: 20px;
    }
}
</style>
